"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { leftStepDescriptions } from "./proposal-form-constants";
type ProposalStepperProps = {
  activeStep: number;
  locked?: boolean;
  mobile?: boolean;
  onStepChange: (step: number) => void;
};
export function ProposalStepper(t0) {
  const $ = _c(7);
  const {
    activeStep,
    locked: t1,
    mobile: t2,
    onStepChange
  } = t0;
  const locked = t1 === undefined ? false : t1;
  const mobile = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== activeStep || $[1] !== locked || $[2] !== mobile || $[3] !== onStepChange) {
    t3 = leftStepDescriptions.map((description, index) => {
      const active = index === activeStep;
      const completed = index < activeStep;
      const disabled = locked || index > activeStep;
      if (mobile) {
        return <button className={cn("shrink-0 font-bricolage text-sm transition-opacity", disabled ? locked ? "cursor-default text-white/80" : "cursor-not-allowed text-white/20" : "cursor-pointer text-white/80")} data-step-index={index} disabled={disabled} key={description} onClick={() => onStepChange(index)} type="button"><span className="flex items-center gap-2 whitespace-nowrap"><span className={cn("inline-flex h-8 min-w-10 items-center justify-center rounded-sm border px-2 font-jakarta text-[14px] font-semibold", active || completed ? "border-primary-300 text-primary-300" : "border-white/20 text-inherit")}>{String(index + 1).padStart(2, "0")}</span>{active ? <span className="text-white">{description}</span> : null}</span></button>;
      }
      return <button className={cn("flex items-center gap-4 text-left font-bricolage text-[16px] leading-[1.2] transition-opacity duration-300", disabled && (locked ? "cursor-default opacity-100" : "cursor-not-allowed opacity-20!"), !disabled && "cursor-pointer")} data-step-index={index} disabled={disabled} key={description} onClick={() => onStepChange(index)} type="button"><span className={cn("font-jakarta text-[14px] leading-[1.2] font-semibold", active || completed ? "text-primary-300" : "")}>{String(index + 1).padStart(2, "0")}</span><span>{description}</span></button>;
    });
    $[0] = activeStep;
    $[1] = locked;
    $[2] = mobile;
    $[3] = onStepChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <>{t3}</>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}